import React from "react";
import "./LegalApp.css";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const phone = "9582822225";
  const message = "Hello, I need help with LegalApp.";
  const waLink = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;

  return (
    <footer
      className="footer-wrapper no-print footer"
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <div className="footer-container">
        <div className="footer-left">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} LexOnAlgo Advisory Pvt. Ltd.
            <span className="footer-rights"> All rights reserved.</span>
          </p>
        </div>

        <div className="footer-right">
          <div className="footer-links-row">
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>
            <span className="footer-sep">|</span>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>

          <div className="footer-contact-row">
            <span>Email: contact@legalapp.in</span>
            <span className="footer-sep">|</span>

            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contact on WhatsApp"
              title="Contact on WhatsApp"
              style={{
                display: "inline-flex",
                alignItems: "baseline",
                gap: 6,
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <FaWhatsapp
                size={18}
                color="#25D366"
                style={{ verticalAlign: "middle", transform: "translateY(1px)" }}
              />
              <span style={{ color: "white" }}>{phone}</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
